export default __webpack_public_path__ + "d6d865744894b1fdf15ebe5c8391c8b2.svg";